import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { Box, Typography, Grid, Link } from "@material-ui/core";
import { AppColor } from "../../styles/AppColor";

const StyledBox = styled(Box)`
  background-color: ${AppColor.quoteBackground};
`

type Property = {
  from: string | undefined;
  label: string | undefined;
}

type TextProp = {
  label: string | undefined;
}

type FromProp = {
  from: string | undefined;
}

const From: FunctionComponent<FromProp> = (props) =>{
  if(props.from !== undefined){
    return(
      <Link color="secondary" href={props.from}>{props.from}</Link>
    )
  }
  else{
    return (<span />)
  }
}


const Text: FunctionComponent<TextProp> = (props) =>{
  if(props.label !== undefined){
    return(
      <Typography variant="body2">{props.label}</Typography>
    )
  }
  else{
    return (<span />)
  }
}

export const Quote: FunctionComponent<Property> = (props) =>(
  <StyledBox mx={0} my={2} p={2} component="blockquote">
    <Box mb={2}>
      <Typography variant="body1">{props.children}</Typography>
    </Box>
    <Grid container direction="column" alignItems="flex-end">
      <Grid item>
        <Text label={props.label} />
      </Grid>
      <Grid item>
        <From from={props.from} />
      </Grid>
    </Grid>
  </StyledBox>
);